import {
  enqueueSnackbar,
  ProviderContext,
  useSnackbar,
  VariantType,
} from 'notistack';

type ShowFlashMessageOptions = {
  message: string;
  providerMethod: ProviderContext['enqueueSnackbar'];
  variant?: VariantType;
  onClose?: () => void;
};

/** @deprecated use enqueueSnackbar */
export const showFlashMessage = (options: ShowFlashMessageOptions) => {
  options.providerMethod(options.message, {
    variant: options.variant,
    onClose: options.onClose,
    preventDuplicate: true,
  });
};

/** @deprecated use enqueueSnackbar */
export const showErrorMessage = (options: ShowFlashMessageOptions) =>
  showFlashMessage({ ...options, variant: 'error' });

/** @deprecated use enqueueSnackbar */
export const useShowFlashMessage = () => {
  const { enqueueSnackbar } = useSnackbar();

  return (options: Omit<ShowFlashMessageOptions, 'providerMethod'>) => {
    showFlashMessage({ ...options, providerMethod: enqueueSnackbar });
  };
};

type NotifyErrorOptions = {
  message: string;
  consoleMessage?: Parameters<typeof console.error>;
};

export const notifyError = (options: NotifyErrorOptions) => {
  const { consoleMessage, message } = options;
  if (consoleMessage) console.error(...consoleMessage);
  enqueueSnackbar(message, { variant: 'error' });
};
